export const layoutMethods = {
    methods:
    {
        clickedColumn (data) {
            this.$emit("selectColumn", data)
        },

        cardColumn (columns) {
            if (columns == 1) return "12"
            else if (columns == 2) return "6"
            else if (columns == 3) return "4"
            else if (columns == 4) return "3"
        }
    }
}
